<template>
  <button
    class="btn"
    :class="{'is-vertical': isVertical}"
    :type="type"
    :disabled="disabled"
    @click="onClick"
  >
    <slot>
      <span v-html="labelText"></span>
    </slot>
  </button>
</template>

<script>
export default {
  name: 'ui-button',
  props: {
    type: { type: String, default: 'button' },
    disabled: { type: Boolean, default: false },
    label: { type: String },
    isVertical: { type: Boolean, default: false }
  },
  computed: {
    labelText () {
      if (!this.isVertical) {
        return this.label
      }
      return this.label.split('').join('<br />')
    }
  },
  methods: {
    onClick (e) {
      if (this.disabled) return
      this.$emit('click', e)
    }
  }
}
</script>
<style lang="stylus">
  .btn{
    &.is-vertical{
      min-width unset !important
    }
  }
</style>
